// 格式化距离 保留一位小数点
export function distanceFormatter (val) {
  return val ? `${val.toFixed(1)} km` : ''
}
// 格式化时间``
export function timeFormatter (val) {
  const len = String(((val / 60) % 60).toFixed(0)).length
  let value
  if (len === 1) value = '0' + String(((val / 60) % 60).toFixed(0))
  else if (len === 2) value = String(((val / 60) % 60).toFixed(0))
  return `${Math.floor(val / 60 / 60)} 時間 ${value} 分`
}



// WEBPACK FOOTER //
// ./src/filters/index.js